import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { ImpalaObjectDataset } from 'app/model/dataset/impala.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ImpalaObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class ImpalaObjectDatasetAdapter extends TabularTypeDatasetAdapter<ImpalaObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: ImpalaObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(ImpalaObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: ImpalaObjectDataset): Promise<ImpalaObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, ImpalaObjectDataset.MODEL);
    }
}
